// components/CustomerInfo.tsx
import React from "react";
import { OrderDetail } from "../hooks/types";
import LabelValueRow from "./LabelValueRow";
import { formatDate } from "src/shared/components/dateUtils";

interface CustomerInfoProps {
  orderData: OrderDetail;
  orderId: string | null;
}

const CustomerInfo: React.FC<CustomerInfoProps> = ({ orderData, orderId }) => {
  const displayOrderId = orderData?.Orderid || orderId || "N/A";

  // Check if multi-car - based on cars array instead of productDetails
  const isMultiCar = orderData?.cars && orderData.cars.length > 1;

  return (
    <>
      <div className="flex justify-between mb-2">
        <LabelValueRow label="Date:" value={formatDate(orderData?.Orderdate || "N/A")} />
        <LabelValueRow label="Order ID:" value={displayOrderId} />
      </div>

      <div className="border-y border-dashed border-black py-2 mb-3">
        <LabelValueRow label="Customer:" value={orderData?.CustomerName || "N/A"} />
        <LabelValueRow label="Phone:" value={orderData?.CustomerPhoneNo || "N/A"} />
        <LabelValueRow label="Payment:" value={orderData?.payments?.[0]?.Paymentmode || "N/A"} />
        {isMultiCar && <LabelValueRow label="Service Type:" value="Multi-Vehicle Service" />}
      </div>
    </>
  );
};

export default CustomerInfo;